import { Component, Input, OnInit, inject } from '@angular/core';
import {FaqGroup} from '../../data/models/faqGroup.model';
import {FaqService} from '../../core/services/faq.service';
import {TranslationService} from "../../core/services/translation.service";
import {FaqGroupComponent} from "../faqgroup/faqgroup.component";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css'],
  imports: [
    FaqGroupComponent,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class FaqComponent implements OnInit {
  private faqService = inject(FaqService);
  translationService = inject(TranslationService);

  @Input() public faqGroups: FaqGroup[] = [];

  ngOnInit() {
    this.faqService.loadFaqGroups().subscribe(groups => {
      this.faqGroups = groups;
    });
  }
}
